import { render, staticRenderFns } from "./WithAutofocus.vue?vue&type=template&id=5dec969a"
import script from "./WithAutofocus.vue?vue&type=script&lang=js"
export * from "./WithAutofocus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports